import { render, staticRenderFns } from "./InterviewsTable.vue?vue&type=template&id=150866c2"
import script from "./InterviewsTable.vue?vue&type=script&lang=js"
export * from "./InterviewsTable.vue?vue&type=script&lang=js"
import style0 from "./InterviewsTable.vue?vue&type=style&index=0&id=150866c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports